import { render, staticRenderFns } from "./rejectModal.vue?vue&type=template&id=b3a567da&scoped=true"
import script from "./rejectModal.vue?vue&type=script&lang=js"
export * from "./rejectModal.vue?vue&type=script&lang=js"
import style0 from "./rejectModal.vue?vue&type=style&index=0&id=b3a567da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a567da",
  null
  
)

export default component.exports